import { render, staticRenderFns } from "./products-units-conversions-edit.vue?vue&type=template&id=a4f823a8&"
import script from "./products-units-conversions-edit.vue?vue&type=script&lang=js&"
export * from "./products-units-conversions-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports